import { Injectable, NgZone } from '@angular/core';
import { initAll, add, track, identify, setUserId, reset, Identify, sessionReplay } from '@amplitude/unified';
import * as amplitude from '@amplitude/unified';
import { environment } from 'src/environments/environment';

@Injectable({
	providedIn: 'root'
})
export class AmplitudeService {

	private initialized = false;
	private API_KEY = environment['amplitude_api_key'] as string | undefined;

	constructor(private ngZone: NgZone) {
		this.init();
	}

	private async init() {
		if (!this.API_KEY) return;

		this.ngZone.runOutsideAngular(async () => {
			add({
				name: 'app-name',
				execute: async (event) => {
					event.event_properties = {
						...event.event_properties,
						app_name: 'Client UX Web',
					};
					return event;
				},
			});

			await initAll(this.API_KEY, {
				analytics: {
					autocapture: true,
					fetchRemoteConfig: true,
				},
				sessionReplay: {
					sampleRate: 1,
				},
			});

			await sessionReplay().init(this.API_KEY, {
				deviceId: amplitude.getDeviceId(),
				sessionId: amplitude.getSessionId(),
			}).promise;

			this.initialized = true;
		});
	}

	identifyUser(userId: string, userProperties: { id: any, name: string, email: string, firmId: any, firm: string }) {
		if (!this.API_KEY) return;

		setUserId(userId);

		const i = new Identify();
		i.set('user_id', userProperties.id);
		i.set('name', userProperties.name);
		i.set('firm_id', userProperties.firmId);
		i.set('firm', userProperties.firm);
		identify(i);
	}

	trackEvent(eventName: string, eventProperties?: Record<string, any>) {
		if (!this.API_KEY) return;

		track(eventName, eventProperties);
	}

	resetAmplitude() {
		if (!this.API_KEY) return;

		reset();
	}
}
